import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const CancelInvoiceButton = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { open: openCancelInvoiceModal } = useModal(ModalId.InvoiceCancellationModal)

  const handleCancelInvoiceClick = useCallback(() => {
    trackInvoiceView('Cancel Invoice clicked')
    openCancelInvoiceModal()
  }, [openCancelInvoiceModal, trackInvoiceView])

  return (
    <Button color="danger" icon="circleX" onClick={handleCancelInvoiceClick} variant="outlined">
      {t('external_invoices.view.cancel')}
    </Button>
  )
}
